export interface UserProfile {
  displayName: string;
  givenName: string;
  surname: string;
  userPrincipalName: string;
  id: string;
  mail: string;
}
